import { KeyContactsList } from "./KeyContactsList";

export default {
  title: "SecurityPortal/Events/KeyContactsList",
  component: KeyContactsList,
  decorators: [
    (Story) => (
      <div
        style={{
          fontFamily: "Helvetica Neue",
          height: "374px",
          width: "554px",
        }}
      >
        <Story />
      </div>
    ),
  ],
};

const Template = (args) => <KeyContactsList {...args} />;

const sampleContact = {
  position: "Event Planner",
  name: "Last, First",
  number: "000-000-0000",
  email: "name@email.com",
};

export const ViewOnly = Template.bind({});
ViewOnly.args = {
  keyContacts: [
    sampleContact,
    { ...sampleContact, position: "Head of Security" },
    { ...sampleContact, position: "Productions Lead" },
    { ...sampleContact, position: "PR Contact" },
    { ...sampleContact, position: "Event Host" },
    { ...sampleContact, position: "Event Representative" },
    { ...sampleContact, position: "Event Representative" },
    { ...sampleContact, position: "Event Representative" },
    { ...sampleContact, position: "Event Representative" },
    { ...sampleContact, position: "Event Representative" },
    { ...sampleContact, position: "Event Representative" },
    { ...sampleContact, position: "Event Representative" },
    { ...sampleContact, position: "Event Representative" },
    { ...sampleContact, position: "Event Representative" },
    { ...sampleContact, position: "Event Representative" },
  ],
  onEdit: undefined,
};

export const WithEdit = Template.bind({});
WithEdit.args = {
  ...ViewOnly.args,
  onEdit: () => alert("onEdit clicked."),
};
